var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{staticClass:"py-0",attrs:{"dark":""}},[_c('v-list-item',{attrs:{"to":_vm.to}},[_c('v-list-item-icon',[_c('v-icon',[_vm._v("mdi-pencil")])],1),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t('myExams')))])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }